import { render } from "./DocumentsDansukGeneral.vue?vue&type=template&id=7c318776&scoped=true"
import script from "./DocumentsDansukGeneral.vue?vue&type=script&lang=js"
export * from "./DocumentsDansukGeneral.vue?vue&type=script&lang=js"

import "./DocumentsDansukGeneral.vue?vue&type=style&index=0&id=7c318776&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c318776"]])

export default __exports__